
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import FacebookSvg from './svg/FacebookSvg.vue';

export default defineComponent({
  name: 'FacebookIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      FacebookSvg: markRaw(FacebookSvg)
    };
  }
});
